export default `
  Methodology Copy
`.trim();



// WEBPACK FOOTER //
// ./src/fixtures/methodology.js